import {
    fadeIn,
    slideToggle,
    slideUp,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const afSection = document.querySelectorAll('.contracts-grid');

    afSection.forEach((section) => {
        const tabTitles = section.querySelectorAll('.cg-tab-item');
        const allTabContents = section.querySelectorAll('.cg-content-item');
        const dropdown = section.querySelector('.cg-dropdown');
        const tabList = section.querySelector('.cg-tabs');

        if (dropdown && tabTitles.length > 0) {
            dropdown.querySelector('span').innerHTML = tabTitles[0].innerHTML;
        }

        const handleDropdownToggle = () => {
            if (window.innerWidth < 767 && dropdown) {

                dropdown.addEventListener('click', toggleDropdown);
                document.addEventListener('click', function(e) {
                    if (!section.contains(e.target)) {
                        dropdown ?.classList.remove('is-open');
                        slideUp(tabList);
                    }
                });

                tabTitles.forEach(tabTitleEle => {
                    tabTitleEle.addEventListener('click', function() {
                        if (dropdown) {
                            dropdown.querySelector('span').innerHTML = this.innerHTML;
                            dropdown.classList.remove('is-open');
                            slideUp(tabList);
                        }
                    });
                });
            } else {
                dropdown ?.removeEventListener('click', toggleDropdown);
                dropdown ?.classList.remove('is-open');
                tabList ?.removeAttribute('style');
            }
        };

        const toggleDropdown = function(event) {
            event.stopPropagation();
            this.classList.toggle('is-open');
            slideToggle(tabList);
        };

        handleDropdownToggle();

        window.addEventListener('resize', handleDropdownToggle);

        tabTitles.forEach(tabTitleEle => {
            tabTitleEle.addEventListener('click', function() {
                const parent = this;
                const isOpen = parent.classList.contains('is-active');
                const targetSelector = this.dataset.href;
                const targetContent = section.querySelector('.cg-content-item[data-id="' + targetSelector + '"]');

                if (isOpen) {
                    return;
                }

                const allTabItems = parent.parentElement.children;
                Array.from(allTabItems).forEach(item => item.classList.remove('is-active'));

                allTabContents.forEach(content => {
                    content.style.display = 'none';
                });

                parent.classList.add('is-active');
                if (targetContent) {
                    fadeIn(targetContent);
                }

                if (dropdown) {
                    dropdown.querySelector('span').innerHTML = this.innerHTML;
                }
            });
        });
    });
});